import { useMutation, useQueryClient } from "@tanstack/react-query";

import { PublicApiError, submitSurveyAnswer } from "../api/client";
import type { SubmitAnswerRequest, SurveyStateResponse } from "../api/types";

export function useSubmitAnswer(token: string | undefined) {
  const qc = useQueryClient();
  return useMutation<SurveyStateResponse, Error, SubmitAnswerRequest>({
    mutationFn: (body) => {
      if (!token) throw new Error("missing survey token");
      return submitSurveyAnswer(token, body);
    },
    onSuccess: (data) => {
      if (token) qc.setQueryData(["survey", "pmf", token], data);
    },
    onError: (err) => {
      // 409 (already completed) and 410 (expired) mean the server has the
      // authoritative terminal state — refetch GET so the page transitions
      // to SurveyThankYou or SurveyExpired instead of staying stuck.
      if (err instanceof PublicApiError && (err.status === 409 || err.status === 410)) {
        if (token) qc.invalidateQueries({ queryKey: ["survey", "pmf", token] });
      }
    },
  });
}
